export enum Integration {
  Greenhouse = 'Greenhouse',
  Lever = 'Lever'
}
